import { useTheme } from "@mui/material";

function NotFoundIcon() {
  const theme = useTheme();
  return (
    <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 10" width="500" height="250">
      <path fill="none" d="m-2-7h24v24h-24z" />
      <path
        fill="none"
        stroke={theme.palette.primary.main}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m1 1v3q0 0.2 0.1 0.4 0.1 0.2 0.2 0.3 0.1 0.1 0.3 0.2 0.2 0.1 0.4 0.1h3"
      />
      <path fill="none" stroke={theme.palette.primary.main} strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m5 1v8" />
      <path
        fill="none"
        stroke={theme.palette.primary.main}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m15 1v3q0 0.2 0.1 0.4 0.1 0.2 0.2 0.3 0.1 0.1 0.3 0.2 0.2 0.1 0.4 0.1h3"
      />
      <path fill="none" stroke={theme.palette.primary.main} strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m19 1v8" />
      <path
        className="AnimatedPathScale"
        fill="none"
        stroke={theme.palette.primary.main}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m8 3v4c0 0.5 0.2 1 0.6 1.4 0.4 0.4 0.9 0.6 1.4 0.6 0.5 0 1-0.2 1.4-0.6 0.4-0.4 0.6-0.9 0.6-1.4v-4c0-0.5-0.2-1-0.6-1.4-0.4-0.4-0.9-0.6-1.4-0.6-0.5 0-1 0.2-1.4 0.6-0.4 0.4-0.6 0.9-0.6 1.4z"
      />
    </svg>
  );
}

export default NotFoundIcon;
